<div class="container"><br>
  <div class="form-group">
    <label>{{question.question_copy}}</label>
    <input currencyMask
           [options]="maskOptions"
           type="tel"
           [class]="'form-control answers ' + question.cent_aq_question_id"
           [(ngModel)]="answer"
           (ngModelChange)="onChange(0)"
           [id]="question.cent_aq_question_id"
           [placeholder]="'Limit ' + (currentVap.value_min | currency:'ZAR':'R':'1.0-0') + ' - ' +
           (currentVap.value_max | currency:'ZAR':'R':'1.0-0')">
  </div>
</div>
